import React, { useState, useEffect } from "react";
import Papa from "papaparse";
import "./About.css";
import Info from "../HomePage/Info";
import BackToTopIcon from "../Common/BackToTopIcon";


const AboutUs = () => {
  const [peopleData, setPeopleData] = useState([]);

  // Parse CSV on mount
  useEffect(() => {
    Papa.parse("/aboutusicons/sortedPeople.csv", {
      download: true,
      header: true,
      complete: (results) => {
        const cleanedData = results.data.map((row) => {
          // Replace '�' with a blank or another character
          for (const key in row) {
            if (typeof row[key] === "string") {
              row[key] = row[key].replace(/�/g, " ");
            }
          }
          return row;
        });
        setPeopleData(cleanedData);
      },
    });
  }, []);

  return (
    <div className="AboutUs">
      <BackToTopIcon />

      <div className="about-container">

        <section className="about-section about-section-people" id="our-people">
          <div className="home-block-header about-section-header">
            <img src="/aboutusicons/people.svg" alt="People Icon" />
            <h1>Our People</h1>
          </div>

          <div className="abt-people-grid">
            {peopleData.map((person, index) => {
              if (!person["First Name"] && !person["Last Name"]) {
                return null; // Skip entries without a name
              }
              const firstName = person["First Name"]?.trim() || "";
              const lastName = person["Last Name"]?.trim() || "";
              const fullName = `${firstName} ${lastName}`.trim();
              const slug = fullName.toLowerCase().replace(/\s+/g, "-");
              const institution = person["Institution"] || "";
              const projectRole =
                person[
                "Project Role (i.e. Co-PI, Contributor, Data Ranger, etc.)"
                ] || "";
              const bio = person["Bio - 215 characters, including spaces"] || "";

              const imageName = `${firstName} ${lastName}.jpg`;
              const imageSrc = `/aboutusicons/contributorphotos/${imageName}`;

              return (
                <article className="abt-person-card" key={slug || index} id={`person-${slug}`}>
                  <div className="abt-people-photos">
                    <img src={imageSrc} alt={fullName} />
                    <p className="abt-description">{projectRole}</p>
                  </div>
                  <div className="abt-people-desc">
                    <h2 className="abt-people-name">{fullName}</h2>
                    <p className="abt-people-title">{institution}</p>
                    <p className="abt-people-short">{bio}</p>
                  </div>
                </article>
              );
            })}
          </div>
        </section>

        <section className="about-section about-section-funding" id="funding-agencies">
          <div className="home-block-header about-section-header">
            <img src="/aboutusicons/funding.svg" alt="Funding Icon" />
            <h1>Funding Agencies</h1>
          </div>

          <div className="abt-funding-container">
            <div className="abt-funders">
              <img
                src="/aboutusicons/Mellon2x.svg"
                alt="Logo for Mellon Foundation"
                title="Mellon Foundation"
                onClick={() => window.open("https://mellon.org", "_blank")}
              />
              <p>Andrew W. Mellon Foundation</p>
            </div>
            <div className="abt-funders">
              <img
                src="/aboutusicons/neh.svg"
                alt="Logo for National Endowment for the Humanities"
                title="National Endowment for the Humanities"
                onClick={() => window.open("https://www.neh.gov", "_blank")}
              />
              <p>National Endowment for the Humanities</p>
            </div>
          </div>

          <p className="abt-funding-copy">
            The Black Literature Network is funded by a generous grant from the
            Public Knowledge division of the Mellon Foundation. The Archives
            section of this site is also supported by a Digital Humanities
            Advancement Grant from the National Endowment for the Humanities.
          </p>
        </section>
      </div>
    </div>
  );
};

export default AboutUs;
